import { useEffect, useState } from "react";
import { UserInfo } from "@/interfaces/user-interface";
import { readItems, readMe } from "@directus/sdk";
import directus from "@/lib/directus";


export default function useFindUser() {
    const [user, setUser] = useState<UserInfo | undefined>(undefined);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCurrentUser = async () => {
            try {

                const accessToken = JSON.parse(localStorage.getItem('directus_auth') || '{}').access_token;
                if (accessToken) {
                    const currentUser = await directus.request(readMe());
                    if (currentUser) {

                        const commercialRelations = await directus.request(readItems("commercial_relations", {
                            filter: {
                                user_id: {
                                    id: {
                                        _eq: currentUser.id,
                                    },
                                },
                            },
                        }));

                        if (commercialRelations && commercialRelations.length > 0) {
                            const phoneNumber = commercialRelations[0].commercial_phoneNumber;
                            const balance = commercialRelations[0].balance;
                            currentUser.phone_number = phoneNumber;
                            currentUser.balance = balance;
                        }

                        setUser(currentUser as UserInfo);
                    } else {
                        setUser(undefined);
                    }
                }
            } catch (error) {
                console.error("Erreur lors de la récupération de l'utilisateur:", error);
                setUser(undefined);
            } finally {
                setLoading(false);
            }
        };

        fetchCurrentUser();
    }, []);

    return {
        user,
        setUser,
        isLoading,
    };
}
